import Glide, { Controls, Breakpoints, Autoplay } from '@glidejs/glide/dist/glide.modular.esm'

if(document.querySelectorAll('.glide').length > 0) {
  var glide = document.querySelectorAll('.glide')

  glide.forEach( ( elem ) => {
    new Glide( elem, {
      type: 'slider',
      autoplay: 5000,
      hoverpause: true,
    }).mount({ Controls, Breakpoints, Autoplay })
  } )
}

if(document.querySelectorAll('.hero-glide').length > 0) {
  var heroGlide = document.querySelectorAll('.hero-glide')

  heroGlide.forEach( ( elem ) => {
    new Glide( elem, {
      type: 'slider',
      autoplay: 5000,
      hoverpause: true,
    }).mount({ Controls, Breakpoints, Autoplay })
  } )
}

if(document.querySelectorAll('.product-glide').length > 0) {
  var productGlide = document.querySelectorAll('.product-glide')

  productGlide.forEach( ( elem ) => {
    new Glide( elem, {
      type: 'carousel',
      perView: 4,
      gap: 0,
      breakpoints: {
        768: {
          perView: 2
        }
      }
    }).mount({ Controls, Breakpoints, Autoplay })
  } )
}

